module.exports = __webpack_public_path__ + "img/win102.c253741d.png";